document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.blog-faqs .faq-item');
    console.log(faqItems);

    faqItems.forEach((item) => {
      const button = item.querySelector('.faq-question');
      const icon = item.querySelector('.faq-icon');

      button.addEventListener('click', function () {
        const isActive = item.classList.contains('active');

        faqItems.forEach((i) => {
          i.classList.remove('active');
        });

        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  });
